import { EventRow } from "@/components/EventRow";

export const LeagueGroups = ({ events, showOdds = true, empty = "No matches right now." }) => {
  if (!events) return <div className="p-8 text-center text-sm text-slate-400">Loading matches…</div>;
  if (!events.length)
    return (
      <div data-testid="events-empty" className="rounded-lg border border-dashed border-[#1E293B] p-10 text-center text-sm text-slate-400">
        {empty}
      </div>
    );
  const groups = {};
  events.forEach((e) => {
    const k = `${e.sport_name} · ${e.league}`;
    (groups[k] = groups[k] || []).push(e);
  });
  return (
    <div className="space-y-4">
      {Object.entries(groups).map(([k, evs], i) => (
        <section
          key={k}
          className="rise-in overflow-hidden rounded-lg border border-[#1E293B] bg-[#121824]"
          style={{ animationDelay: `${Math.min(i, 8) * 50}ms` }}
        >
          <header className="flex items-center justify-between border-b border-[#1E293B] bg-[#0E131F] px-4 py-2.5">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-slate-200">{k}</h3>
            <span className="text-[11px] text-slate-500">{evs[0].country}</span>
          </header>
          {evs.map((e) => (
            <EventRow key={e.id} ev={e} showOdds={showOdds} />
          ))}
        </section>
      ))}
    </div>
  );
};
